import React from 'react';
import About from '../component/about/About';
import Faq from '../component/about/Faq';
import Background from '../component/about/Background';

function AboutPage() {
  return (
    <main>
      <About />
      <Faq/>
      {/* <Background /> */}
      {/* <p>
        This site proudly made with reactJs, one of the best library for
        javascript
      </p> */}
    </main>
  );
}

export default AboutPage;
